// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__xM8-Q {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-right: 8px;
  height: 40px;
}

.styles_clientContainer__UopYz {
  display: flex;
  position: relative;
  gap: 16px;
  height: 91vh;
  background: #f5f5f5;
  margin-left: 15px;
}

.styles_clientFormContainer__8l7tt {
  flex: 0.4 1;
  background: #ffffff;
  z-index: 10;
  border-radius: 8px;
  border: 1px solid var(--gray-200, #eaecf0);
  height: calc(100vh - 90px);
}

.styles_defaultText__Dxj\\+I {
  color: #d3d3d3;
}

.styles_clientForm__PfkVE {
  padding: 16px;
  padding-top: 0;
}

.styles_clientFormTitle__joW1\\+ {
  color: var(--gray-700, #344054);
  font-family: Poppins;
  font-style: normal;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-transform: uppercase;
}

.styles_clientDetails__yPod4 {
  padding: 0 24px;
}

.styles_clientField__UcTad {
  padding: 24px 0;
}

.styles_clientResponse__J3sjS {
  color: var(--gray-black, #000);
  /* Body/02 Standard/Emphasis */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
@media (max-width: 1440px) {
  .styles_clientResponse__J3sjS {
    font-size: 12px;
  }
}

.styles_padding__oS5-C {
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.styles_warehouseInstructionContainer__uBThg {
  height: calc(100vh - 467px);
  overflow: auto;
}

.styles_warehouseInstructionTableContainer__R2mGn {
  height: calc(100vh - 467px);
  overflow: auto;
}

.styles_instuctionContainer__Wcucs {
  height: calc(100vh - 455px);
  overflow: auto;
}

@media screen and (max-width: 1720px) {
  .styles_warehouseInstructionTableContainer__R2mGn {
    height: calc(100vh - 450px);
  }
  .styles_warehouseInstructionContainer__uBThg {
    height: calc(100vh - 450px);
  }
}
@media screen and (max-width: 1536px) {
  .styles_warehouseInstructionTableContainer__R2mGn {
    height: 260px;
  }
  .styles_warehouseInstructionContainer__uBThg {
    height: 260px;
  }
}
@media screen and (max-width: 1440px) {
  .styles_container__xM8-Q {
    height: 30px;
    gap: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/organisms/generateClient/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,0CAAA;EACA,0BAAA;AACF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,cAAA;AAAF;;AAGA;EACE,+BAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,8BAAA;EACA,8BAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAAF;AACE;EARF;IASI,eAAA;EAEF;AACF;;AACA;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAEF;;AACA;EACE,2BAAA;EACA,cAAA;AAEF;;AACA;EACE,2BAAA;EACA,cAAA;AAEF;;AACA;EACE,2BAAA;EACA,cAAA;AAEF;;AACA;EACE;IACE,2BAAA;EAEF;EACA;IACE,2BAAA;EACF;AACF;AAEA;EACE;IACE,aAAA;EAAF;EAGA;IACE,aAAA;EADF;AACF;AAIA;EACE;IACE,YAAA;IACA,SAAA;EAFF;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-right: 8px;\n  height: 40px;\n}\n\n.clientContainer {\n  display: flex;\n  position: relative;\n  gap: 16px;\n  height: 91vh;\n  background: #f5f5f5;\n  margin-left: 15px;\n}\n\n.clientFormContainer {\n  flex: 0.4;\n  background: #ffffff;\n  z-index: 10;\n  border-radius: 8px;\n  border: 1px solid var(--gray-200, #eaecf0);\n  height: calc(100vh - 90px);\n  // max-height:87vh;\n}\n\n.defaultText {\n  color: #d3d3d3;\n}\n\n.clientForm {\n  padding: 16px;\n  padding-top: 0;\n}\n\n.clientFormTitle {\n  color: var(--gray-700, #344054);\n  font-family: Poppins;\n  font-style: normal;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  text-transform: uppercase;\n}\n\n.clientDetails {\n  padding: 0 24px;\n}\n\n.clientField {\n  padding: 24px 0;\n}\n\n.clientResponse {\n  color: var(--gray-black, #000);\n  /* Body/02 Standard/Emphasis */\n  font-family: Poppins;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  @media (max-width: 1440px) {\n    font-size: 12px;\n  }\n}\n\n.padding {\n  padding: 0 !important;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.warehouseInstructionContainer {\n  height: calc(100vh - 467px);\n  overflow: auto;\n}\n\n.warehouseInstructionTableContainer {\n  height: calc(100vh - 467px);\n  overflow: auto;\n}\n\n.instuctionContainer {\n  height: calc(100vh - 455px);\n  overflow: auto;\n}\n\n@media screen and (max-width: 1720px) {\n  .warehouseInstructionTableContainer {\n    height: calc(100vh - 450px);\n  }\n\n  .warehouseInstructionContainer {\n    height: calc(100vh - 450px);\n  }\n}\n\n@media screen and (max-width: 1536px) {\n  .warehouseInstructionTableContainer {\n    height: 260px;\n  }\n\n  .warehouseInstructionContainer {\n    height: 260px;\n  }\n}\n\n@media screen and (max-width: 1440px) {\n  .container {\n    height: 30px;\n    gap:12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__xM8-Q`,
	"clientContainer": `styles_clientContainer__UopYz`,
	"clientFormContainer": `styles_clientFormContainer__8l7tt`,
	"defaultText": `styles_defaultText__Dxj+I`,
	"clientForm": `styles_clientForm__PfkVE`,
	"clientFormTitle": `styles_clientFormTitle__joW1+`,
	"clientDetails": `styles_clientDetails__yPod4`,
	"clientField": `styles_clientField__UcTad`,
	"clientResponse": `styles_clientResponse__J3sjS`,
	"padding": `styles_padding__oS5-C`,
	"warehouseInstructionContainer": `styles_warehouseInstructionContainer__uBThg`,
	"warehouseInstructionTableContainer": `styles_warehouseInstructionTableContainer__R2mGn`,
	"instuctionContainer": `styles_instuctionContainer__Wcucs`
};
export default ___CSS_LOADER_EXPORT___;
